export default __webpack_public_path__ + "static/media/ILUSTRACIONES_03.113ed278.png";